export default "__VITE_ASSET__8wgpqQxz__"